import styled from "styled-components";

const CompanyListWrap = styled.div`
  padding: 12px 0;
`

export default CompanyListWrap